import React, { useEffect, useState } from "react";
import "../index.css"
import { Button } from "../../../helpers";
import EditChequeBook from "./EditChequeBook";
import { Dialog } from "primereact/dialog";
import { useDispatch ,useSelector } from "react-redux";
import { deleteChequeBook } from "../../../services/api/chequeBooks";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { deleteChequeBookAction } from "../../../services/redux/reducers/common";
import { fetchChequeBooks } from "../../../services/redux/reducers/commonThunk";

const ViewChequeBook = (props) =>{
    const { setVisibleViewChequeBook } = props
    
    const [visibleEditChequeBook, setVisibleEditChequeBook] = useState(false)
    const [editChequeBook, setEditChequeBook] = useState("")

    const chequeBooks = useSelector(state => state.common.chequeBooks)
    const bankDetails = useSelector(state => state.userDetails.PMCompanyDetails.companyBankAccounts)

    const dispatch = useDispatch()
    
    const handleEditChequeBook = (bankDetails, chequeBook) => {
        setEditChequeBook({
            chequeBookId: chequeBook.chequeBookId,
            bankAccId: bankDetails.bankAccId,
            bankName: bankDetails.bankName,
            accNo: bankDetails.accNo,
            ifscCode: bankDetails.ifscCode,
            chequeSeriesFrom: chequeBook.chequeSeriesFrom,
            chequeSeriesTo: chequeBook.chequeSeriesTo
        })
    }

    const handleOnDeleteChequeBook = async (chequeBookId) => {
        if(window.confirm("Do you want to remove the cheque book")){
            const deleteChequeBookResponse = await deleteChequeBook(chequeBookId)
            if(deleteChequeBookResponse.failure){
                return dispatch(raiseToast({severity:'error', summary: 'Cheque Book', detail: deleteChequeBookResponse.data.error, life: 3000}))
            }else{
                setVisibleViewChequeBook()
                const updatedChequeBookList = chequeBooks.map((eachChequeBook) => {
                    if(eachChequeBook.chequeBookId === chequeBookId){
                        return {
                            statudId: 2,
                            ...eachChequeBook
                        }
                    }else {
                        return eachChequeBook
                    }
                })
                dispatch(deleteChequeBookAction(updatedChequeBookList))
                dispatch(fetchChequeBooks(false))
                return dispatch(raiseToast({severity:'success', summary: 'Cheque Book', detail: "Deleted successfully", life: 3000}))
            }
        }
    }

    return(
        <div >
            <div className="cheque-container">
                {
                    chequeBooks.map(eachChequeBook => {
                        const relatedBankDetails = bankDetails.find((each) => each.bankAccId === eachChequeBook.bankAccId)
                        const customStyle = eachChequeBook.statusId === 1 ? '' : 'inactve-card'
                        return (
                            <div className={`cheque-card p-card ${customStyle}`}>
                                <div>
                                    <h4> {relatedBankDetails?.bankName}</h4>
                                    <p><span>A/C No</span>: {relatedBankDetails?.accNo}</p>
                                    <p><span>Cheque Series:</span>{`from ${eachChequeBook.chequeSeriesFrom} to ${eachChequeBook.chequeSeriesTo}`}</p>
                                </div>
                                <div className="hr-line"></div>
                                <div className="cheque-card-footer">
                                    <Button className="edit-btn mr-2" rounded onClick={() => {setVisibleEditChequeBook(true); handleEditChequeBook(relatedBankDetails, eachChequeBook)}} permissions={[111]} ><i className="pi pi-file-edit align-self-center"></i></Button>
                                    <Button className="trash-btn" rounded onClick={() => handleOnDeleteChequeBook(eachChequeBook.chequeBookId)} permissions={[111]}><i className="pi pi-trash align-self-center"></i></Button> 
                                </div>
                            </div>
                        )
                    })
                }
                <Dialog header="Edit Cheque Book" visible={visibleEditChequeBook} style={{ width: '50vw', height: '50vh' }} onHide={() => setVisibleEditChequeBook(false)}>
                    <EditChequeBook chequeBookDetails={editChequeBook} setVisibleEditChequeBook={() => setVisibleEditChequeBook(false)}/>
                </Dialog>
            </div>
        </div>
    )
}

export default ViewChequeBook;